import { settings } from '../engine/settings-sidecar'
import { l } from '../lib/imports'
import { ISavedData } from './saverOrganizer'
import { saverOrganizer } from './saverOrganizer-sidecar'

interface IMapSaverData {
  filename: string
  files: string[]
}

let data: IMapSaverData = {
  filename: 'default',
  files: [],
}

export const setFilename = (newFilename: string) => {
  data.filename = newFilename
}

export const _saveNow = () => {
  let filename = data.filename

  let d = saverOrganizer.save()

  fetch(`http://localhost:4500/put/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      filename: filename,
      data: JSON.stringify(d, null, 2),
    }),
  })
    // .then((r) => r.json())
    .then((data) => console.log(data))
}

export const saveLater = l.debounce(_saveNow, 500)

export const loadNow = async (filename: string, afterLoad?: () => void) => {
  // monsters.killAll()
  // objects.killAll()

  let result = await fetch(`http://localhost:4500/get/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      filename: filename,
    }),
  })
  console.log('data', result)
  let d = await result.text()
  let fn = d.substring(0, d.indexOf('\n'))
  d = d.substring(d.indexOf('\n'))
  console.log('loaded', fn)
  let json = JSON.parse(d)

  let dt: ISavedData = json as ISavedData

  saverOrganizer.load(dt)

  data.filename = filename
  settings.update({ filename })

  if (afterLoad) {
    afterLoad()
  }
  //console.log('data d', d, fn)
}

export const getFilesList = async () => {
  let result = await fetch(`http://localhost:4500/list/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({}),
  })
  let j = await result.json()
  let list: string[] = j
  console.log('list =', result, j)
  return list
  // // .then((r) => r.json())
  // .then((data) => console.log(data))
}
